import React, { useState } from 'react';

import BaseDialog from '@appsinti/ui-core/dialogs/BaseDialog';
import { PrimaryButton, SecondaryButton } from '@etiquette-ui/buttons';

import { Option } from '@appsinti/ui-core/dropdown/interfaces/IGroupOption';
import { MiddleWidth } from '@appsinti/ui-core/styles';

import useI18n from '@appsinti/i18n/useI18n';

import Completed from '../components/Completed';
import { Container, CustomRow, Text } from '../styles';
import { ListItem } from './styles';

const STATUS: { [key: string]: string } = {
  'pending': 'pending',
  'completed': 'completed'
};

type ReplaceHomeCameraDialogProps = {
  onClose: () => void;
  newOption: Option;
  selectedOptions: Option[];
  setSelectedOption: (options: Option[] | undefined) => Promise<boolean>;
};
const ReplaceHomeCameraDialog: React.FC<ReplaceHomeCameraDialogProps> = ({ onClose, newOption, selectedOptions, setSelectedOption }) => {
  const [processStatus, setProcessStatus] = useState<string>(STATUS['pending']);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [editedOptions, setEditedOptions] = useState<{ new: Option, old: Option | undefined }>({ new: newOption, old: undefined });
  const { translate } = useI18n();

  const selectOldOption = (oldOption: Option | undefined) => {
    setEditedOptions((current) => ({ ...current, old: oldOption }));
  };

  const changeCamera = async () => {
    const oldOption = editedOptions.old;
    if (!oldOption) return;

    const remainOptions = selectedOptions.filter(option => option.value !== oldOption.value);
    const success = await setSelectedOption([...remainOptions, editedOptions.new]);
    setIsSuccess(success);
    setProcessStatus(STATUS['completed']);
  };

  const getListLabel = (index: number, label: string): string => {
    switch (index) {
      case 0:
        return `${translate('Top camera')}: ${label}`;
      case (selectedOptions.length - 1):
        return `${translate('Bottom camera')}: ${label}`;
      default:
        return `${index} ${translate('camera')}: `;
    }
  };

  return (
    <BaseDialog open={true} onClose={onClose} dismissible={false} isResponsive={true} header={translate('Update Camera')}>
      {(processStatus === STATUS['pending']) &&
        (<Container>
          <Text>
            <strong>{translate('New camera')}: </strong>{newOption.label}
          </Text>
          <Text>
            {translate('You will change the camera view from the Appsinti home. Choose one below to replace:')}
          </Text>

          {selectedOptions.map((selectedOption, index) => (
            <ListItem key={selectedOption.value}>
              <input type="radio" id={selectedOption.value} name="cameraListItem" value={selectedOption.value}></input>
              <Text onClick={() => selectOldOption(selectedOption)}>
                <label htmlFor={selectedOption.value}>
                  {getListLabel(index, selectedOption.label)}
                </label>
              </Text>
            </ListItem>
          ))}

          <CustomRow style={{ justifyContent: 'space-between' }}>
            <MiddleWidth>
              <SecondaryButton onClick={() => { onClose(); selectOldOption(undefined); }}>{translate('Cancel')}</SecondaryButton>
            </MiddleWidth>
            <MiddleWidth>
              <PrimaryButton onClick={changeCamera}>{translate('Update')}</PrimaryButton>
            </MiddleWidth>
          </CustomRow>
        </Container>
        )}

      {(processStatus === STATUS['completed']) &&
        (<Completed
          onClose={onClose}
          isSuccess={isSuccess}
        />)}

    </BaseDialog>
  );
};
export default ReplaceHomeCameraDialog;
